import { UserType } from 'ha/constants/UserType';

export const enum AuthType {
  login = 'login',
  register = 'register',
}

export interface LegacyUser {
  CompletedBookings: number;
  CountryCode?: string;
  Email: string;
  EmailVerified: boolean;
  FirstName: string;
  HasFacebook: boolean;
  HasPaymentMethod: boolean;
  HasPhone: boolean;
  ID: number;
  LastActivityAt: string;
  LastName: string;
  ListingsCount?: number;
  Location?: string;
  Phone?: string;
  RegistrationDate: string;
  ResponseRate: number;
  ResponseTime: number;
  SpokenLanguages: string[];
  Type: UserType;
  UniID?: number;
  avatarURL?: string;
  birthDate?: string;
  description?: string;
  isAdmin: boolean;
  isAliased: boolean;
  isTrusted: boolean;
  isPartner: boolean;
  nationality?: string;
  study?: string;
  uniID?: number;
  work?: string;
  Name: string;
}
